const SET_LAYOUT = "SET_LAYOUT";
const SET_COMPONENT = "SET_COMPONENT";


export default Object.freeze({ SET_LAYOUT, SET_COMPONENT });
export { SET_LAYOUT, SET_COMPONENT };